import React from 'react';
import PropTypes from 'prop-types';
import NotificationContent from '../../contexts/notification-context';
import Notification from './notification';

export default function Notifications(props) {
  const [notification, setNotification] = React.useState(undefined);
  const notificationContextValue = {
    showNotification,
    clearNotification,
    showSuccessNotification,
    showDangerNotification,
    showWarningNotification,
    showInfoNotification,
  };

  function showNotification(options) {
    const {dismissable, ...rest} = options;
    if (dismissable) {
      options = {
        onDismiss: clearNotification,
        ...rest,
      };
    }
    setNotification(options);
  }

  function clearNotification() {
    setNotification(undefined);
  }

  function showSuccessNotification(message) {
    showNotification({
      variant: 'success',
      icon: 'check',
      message,
      dismissable: false,
    });
  }

  function showDangerNotification(message) {
    showNotification({
      variant: 'danger',
      icon: 'exclamation-triangle',
      message,
      dismissable: true,
    });
  }

  function showWarningNotification(message) {
    showNotification({
      variant: 'warning',
      icon: 'exclamation-triangle',
      message,
      dismissable: true,
    });
  }

  function showInfoNotification(message) {
    showNotification({
      variant: 'info',
      icon: 'question-circle',
      message,
      dismissable: true,
    });
  }

  return (
    <NotificationContent.Provider value={notificationContextValue}>
      {notification ? (
        <div id="app-notifications">
          <Notification {...notification} />
        </div>
      ) : (
        <></>
      )}
      {props.children}
    </NotificationContent.Provider>
  );
}

Notifications.propTypes = {
  children: PropTypes.node.isRequired,
};
